import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import Modal from '@material-ui/core/Modal';

import X from 'src/assets/images/vectors/x.svg'
import ContactFormBanner from 'src/assets/images/vectors/contact-form-banner.svg'

import Form from 'src/components/atoms/Form'
import ContactFormInput from 'src/components/atoms/ContactFormInput'
import Textarea from 'src/components/atoms/Textarea'
import Button from 'src/components/atoms/Button'

import {
  validateContactFormField,
  validateContactFormValues
} from 'src/features/auth/duck/schema'

import { showToastRoutine } from 'src/features/toast/duck/actions'
import { getContactFormErrorMessage } from 'src/features/auth/duck/errors'
import { contactFormPost } from 'src/services/ContactFormService'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const emptyValues = {
  name: '',
  email: '',
  phone: '',
  message: '',
  termsAndConditions: false,
}

export default function ContactFormModal(props) {
  const { t } = useTranslation()
  const [values, setValues] = useState({ ...emptyValues })
  const [valid, _validateSchema] = useState(false)
  const dispatch = useDispatch()

  const handleOnChange = (name, value) => 
    setValues({ ...values, [name]: value })

  const handleCheckboxChange = e => {
    setValues({ ...values, termsAndConditions: e.target.checked })
  }

  useEffect(() => {
    validateContactFormValues(values, _validateSchema)
  }, [values])

  useEffect(() => {
    setValues({ ...emptyValues })
  }, [props.open])

  const handleSubmit = e => {
    validateContactFormValues(values, _validateSchema)
    e.preventDefault()

    if (!valid) {
      return;
    }

    contactFormPost(values).then(() => {
      setValues({ ...emptyValues });
      props.onClose();
    }).catch(() => {
      dispatch(showToastRoutine(getContactFormErrorMessage()))
    })
  }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.onClose}
      >
        <ModalBody>
          <div className='contact-form-modal'>
            <div className='close-btn-container'>
              <img tabIndex={0} src={X} alt='close-button' onClick={props.onClose} role='button' />
            </div>
            <div className='banner-container'>
              <img src={ContactFormBanner} alt='contact-form-banner' />
              <div>{t('form.contactForm.questions')}</div>
              <div>{t('form.contactForm.contactUs')}</div>
            </div>
            <div className='form-container'>
              <Form onSubmit={handleSubmit}>
                <ContactFormInput
                  required
                  name='name'
                  label={t('form.name.label')}
                  placeholder={t('form.name.placeholder')}
                  onChange={handleOnChange}
                  validate={validateContactFormField(values)}
                />
                <ContactFormInput
                  required
                  name='email'
                  type='email'
                  label={t('form.email.label')}
                  placeholder={t('form.email.placeholder')}
                  onChange={handleOnChange}
                  validate={validateContactFormField(values)}
                />
                <ContactFormInput
                  name='phone'
                  label={t('form.phoneNumber.label')}
                  placeholder={t('form.phoneNumber.placeholder')}
                  type='tel'
                  onChange={handleOnChange}
                  validate={validateContactFormField(values)}
                />
                <Textarea
                  required
                  name='message'
                  label={t('form.message.label')}
                  placeholder={t('form.message.placeholder')}
                  onChange={handleOnChange}
                  validate={validateContactFormField(values)}
                />
                <FormControlLabel
                  className='termsAndConditons'
                  control={
                    <Checkbox
                      checked={values.termsAndConditions}
                      onChange={handleCheckboxChange}
                      color="primary"
                    />
                  }
                  label={
                    <Trans i18nKey='form.contactForm.termsAndConditions'>
                      <span>0</span>
                      <a href="https://whitelabelcoders.com/app/uploads/WLC_TermsConditions_2021-1.pdf" target="_blank">1</a>
                      <span>2</span>
                      <a href="https://whitelabelcoders.com/privacy-policy/" target="_blank">3</a>
                    </Trans>
                  }
                />
                <Button
                  type='submit'
                  disabled={!valid}
                >
                  {t('form.contactForm.submit')}
                </Button>
              </Form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

const ModalBody = styled.div`
  .contact-form-modal {
    width: 300px;
    padding: 32px;
    background-color: ${props => props.theme.palette.background.paper};
    border-radius: 28px;
    position: fixed;
    top: 72px;
    left: calc(50vw - 170px);
    max-height: calc(100vh - 100px);
    overflow-y: auto;

    ${props => props.theme.breakpointsMedia.desktop} {
      width: 660px;
      left: calc(50vw - 330px);
    }

    .close-btn-container {
      width: 100%;

      img {
        margin-right: 0;
        margin-left: auto;
        display: block;
        cursor: pointer;
      }
    }

    .banner-container {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      img {
        width: 210px;
        margin: 20px 0;
        display: block;
      }

      div {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.5;
      }
    }

    .form-container {
      button {
        width: 100%;
        height: 44px;
        margin-top: 10px;
        margin-bottom: 20px;
      }

      .termsAndConditons {
        margin-top: 16px;

        .MuiFormControlLabel-label {
          font-size: 12px !important;
          font-weight: 500 !important;

          a {
            color: ${props => props.theme.palette.primary.main};
          }
        }
      }
    }
  }
`
